module.exports = __webpack_public_path__ + "static/media/Ticketing-Table-for-7-8.4ff8e373.svg";